import { convertToKey } from '@gonfalon/strings/convertToKey';

import type { EndMark, StartMark } from '../types';

const createMeasureName = (event: string) => {
  return convertToKey(event);
};

const createStartMarker = (measureName: string): StartMark => `${measureName}:start`;
const createEndMarker = (measureName: string): EndMark => `${measureName}:end`;

export const getMeasureMarkers = (event: string) => {
  const measureName = createMeasureName(event);
  return {
    measureName,
    startEvent: createStartMarker(measureName),
    endEvent: createEndMarker(measureName),
  };
};
